import React from "react";
import { HomeOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, DatePicker, Form, Input, Select } from "antd";
import "./attendance_mechanic.css";
import { HiOutlineDocumentCheck } from "react-icons/hi2";
import withAttendanceMechanicLogic from "../../components/hoc_attendance_mechanic";

const AttendanceMechanic: React.FC<any> = ({ form, mechanicList, handleSubmit, handleDateChange, isMechanicLocked, handleSearchMechanic, isMechLoading }) => { 
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };
    const Submitbtn = HiOutlineDocumentCheck as React.ComponentType<any>;

    return (
        <div id="iaid2ou9" style={transformStyle}>
            <div className="gjs-grid-row" id="ixnf">
                <div className="gjs-grid-column" id="i25kk">
                    <Breadcrumb
                        items={[
                            {
                                title: <HomeOutlined />,
                            },
                            {
                                href: "#/dashboard/data_attendance_mechanic",
                                title: (
                                    <>
                                        <span>Transaction Attendance Mechanic</span>
                                    </>
                                ),
                            },
                            {
                                title: "Attendance Mechanic",
                            },
                        ]}
                    />
                </div>
            </div>

            <div className="gjs-grid-row" id="ii35s">
                <div className="gjs-grid-column" id="ieahs">
                    <Button className="gr-button" onClick={handleSubmit}>
                        <Submitbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Submit
                    </Button>
                </div>
            </div>
            <div className="gjs-grid-row" id="iketj">
                <div className="gjs-grid-column" id="iytkp">
                    <Form
                        form={form}
                        layout="horizontal"
                        style={{ maxWidth: 420 }}
                        labelCol={{ style: { width: '150px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                    >
                        <Form.Item
                            label="Date"
                            name="date_trans"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[{ required: true, message: 'Required' }]}
                        >
                            <DatePicker
                                format="DD/MM/YYYY"
                                style={{ width: "100%" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                onChange={(date, dateString) => {
                                    if (typeof dateString === 'string') {
                                        handleDateChange(dateString);
                                    }
                                }}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Name Mechanic"
                            name="name_mechanic"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[{ required: true, message: 'Required' }]}
                        >
                           {mechanicList ? ( 
                                <Select
                                    showSearch
                                    placeholder="Select Mechanic"
                                    optionFilterProp="children" 
                                    onSearch={handleSearchMechanic} 
                                    loading={isMechLoading} 
                                    filterOption={false} 
                                    options={mechanicList}
                                    style={{ width: "100%" }}
                                    disabled={isMechanicLocked}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                    onChange={(value, option: any) => {
                                        form.setFieldsValue({
                                            code_mechanic: value,
                                            foreman: option.foreman
                                        });
                                    }}
                                />
                            ) : (
                                <Input placeholder="No mechanic in your warehouse" readOnly />
                            )}
                        </Form.Item>
                        <Form.Item
                            label="Code Mechanic"
                            name="code_mechanic"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Foreman"
                            name="foreman"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Warehouse"
                            name="warehouse"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                    </Form>
                </div>
            </div>
            <div className="gjs-grid-row" id="ink8r">
                <div className="gjs-grid-column" id="i1kg1">
                </div>
            </div>
        </div>
    );
};

export default withAttendanceMechanicLogic(AttendanceMechanic);